import { Box, Typography } from "@mui/material";
import { SchoolHeader } from "../../fees/receipt/receiptModel";

// How the school appears at the top of printed documents: logo, name, address, contact.
// Mirrors the header of the receipt PDF (ReceiptDocument), without anything receipt-specific.
export const SchoolHeaderPreview = ({ header }: { header: SchoolHeader }) => (
  <Box sx={{ border: "1px solid #d1d5db", borderRadius: 2, bgcolor: "#fff", display: "flex", alignItems: "center", gap: 2, p: 2 }}>
    {header.logo ? (
      <Box component="img" src={header.logo} alt="School logo" sx={{ width: 60, height: 60, objectFit: "contain", flexShrink: 0 }} />
    ) : (
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          border: "1px dashed #d1d5db",
          bgcolor: "#f9fafb",
          display: "grid",
          placeItems: "center",
          fontSize: 10,
          color: "#6b7280",
          flexShrink: 0,
        }}
      >
        LOGO
      </Box>
    )}
    <Box sx={{ flex: 1, minWidth: 0, textAlign: "center", pr: { sm: "60px" } }}>
      <Typography sx={{ color: "#115293", fontWeight: 700, fontSize: { xs: 16, sm: 19 }, lineHeight: 1.3, overflowWrap: "anywhere" }}>{header.name}</Typography>
      <Typography sx={{ color: "#6b7280", fontSize: 13, mt: 0.25, overflowWrap: "anywhere" }}>{header.address}</Typography>
      {header.contact && <Typography sx={{ color: "#6b7280", fontSize: 13, overflowWrap: "anywhere" }}>{header.contact}</Typography>}
    </Box>
  </Box>
);
